module.exports = __webpack_public_path__ + "features-star.3933f6cff8dee0732d4dc793987b6f27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features-star.svg
// module id = 1138
// module chunks = 0